import './Portafolio.css';

function Portafolio() {
  return (
    <section className="portafolio-section py-5">
      <div className="container animate-on-scroll">
        <div className="row align-items-center">

          <div className="col-lg-6 text-center mb-4 mb-lg-0">
            <img src="/img/portafolio.png" alt="Portafolio" className="img-fluid portafolio-img" />
          </div>

          <div className="col-lg-6 text-center text-lg-start">
            <h2 className="fw-bold mb-3 text-primary">¿Listo para comenzar?</h2>
            <p className="fs-5 mb-4 text-muted">
              Nos llena de emoción saber que confías en nosotros para hacer realidad tus ideas. 
              Nuestro mayor compromiso es escuchar, planear contigo y transformar juntos tus sueños en proyectos funcionales y exitosos.
            </p>
            <div className="highlight-box p-3 mt-3">
              <p className="mb-0 fw-semibold">
                ¡Gracias por creer en <span className="text-primary">Code Nest Dev</span>! 
                Estamos listos para poner manos a la obra.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}

export default Portafolio;
